/* Angular Component */
import {
  Component,
  NgZone,
  ApplicationRef,
  ChangeDetectorRef,
} from "@angular/core";
import { UI } from "../../../services/ui.service";
import libraryStore from "../../../services/stores/library.store";
import { AutopilotRepository } from "../../../domain/autopilot-repository";
import { GraphicsRepository } from "../../../domain/graphics-repository";
import { LibraryTypes } from "../../../domain/enums";
import PerfectScrollbar from "perfect-scrollbar";
import { SearchService } from "../../../services/search.service";
import { MediaRepository } from "../../../domain/media-repository";
import { MediaItem } from "../../../domain/media";
import { from, Observable } from "rxjs";
import { Logger } from "app/js/src/infrastructure/logger";

const TAG = "AutopilotAside:";

@Component({
  selector: "autopilot-aside",
  templateUrl: "./autopilotAside.component.html",
  styleUrls: ["./autopilotAside.component.scss"],
  providers: [UI],
})
export class AutopilotAsideComponent {
  autopilotLibrarySubject;
  libraryStore = libraryStore;
  offset = 0;
  Ob: Observable<any>;
  private searchSubscription: any;

  constructor(
    private autopilotRepository: AutopilotRepository,
    private ui: UI,
    private zone: NgZone,
    private graphicsRepository: GraphicsRepository,
    private cd: ChangeDetectorRef,
    private searchService: SearchService,
    private mediaRepository: MediaRepository,
    private changeDetectorRef: ChangeDetectorRef,
    private logger: Logger,
  ) {}

  ngOnDestroy() {
    this.autopilotLibrarySubject.unsubscribe();
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
      this.Ob = null;
    }
  }
  /**
   * Initializing component
   * @return void
   */
  ngOnInit() {
    this.bootScrollHandler();

    this.libraryStore.setLibraryType(LibraryTypes.AutopilotRules);
    this.loadRelevantItems(LibraryTypes.AutopilotRules);
    let currentLibraryType = this.libraryStore.getLibraryType();

    console.log(
      "AutopilotAsideComponent->ngOnInit->currentLibraryType=",
      currentLibraryType,
    );
    this.autopilotLibrarySubject = this.libraryStore.libraryChanged.subscribe(
      (type) => {
        if (currentLibraryType !== type) {
          this.searchService.searchQuery = "";
          //this.searchService.searchMode = type ===  LibraryTypes.Graphics ? 'graphics' : '';
          this.searchService.searchServiceSubject.next(true);
          currentLibraryType = type;
        }
        this.loadRelevantItems(type);
      },
    );
    this.Ob = from(this.searchService.searchServiceSubject);
    this.searchSubscription = this.Ob.subscribe(() => {
      this.offset = 0;
      this.searchService
        .search(this.offset)
        .then((response: any) => {
          this.libraryStore.setLibraryItems(response);
          this.changeDetectorRef.markForCheck();
        })
        .catch((err) => {
          this.logger.error("Could not get media. Error: " + err);
        });
    });
    /* Setup Default */
  }

  /**
   * Handling with scroll in section aside
   * @return void
   */
  bootScrollHandler() {
    const ps = new PerfectScrollbar(".perfect-scroll");
  }

  /**
   * Loading the relevant library
   * @return void
   */
  loadRelevantItems(libraryType) {
    if (typeof libraryType != "string") return;

    /* Prepare library */
    const method = libraryType.toLowerCase() + "Library";

    /* Validate method and dispatch */
    if (typeof this[method] == "function") this[method].call(this);

    // this.selectedTab = libraryType;
  }

  /**
   * Loading Video Rules Library from remote server
   * @return void
   */
  /*videorulesLibrary() {

    this.autopilotRepository.getAllVideoRules().then(((response) => {

      this.libraryStore.setLibraryItems(response);
      this.cd.detectChanges();


    }).bind(this), ((error) => {

    }).bind(this)).catch(((error) => {

    }).bind(this));
  }*/
  videoLibrary() {
    this.offset = null;
    this.searchService
      .search(this.offset)
      .then((response) => {
        this.libraryStore.setLibraryItems(response);
        this.changeDetectorRef.markForCheck();
      })
      .catch((err) => {
        console.error("Could not get media. Error: ", err);
      });
  }

  /**
   * Loading Video Rules Library from remote server
   * @return void
   */
  autopilotrulesLibrary() {
    this.autopilotRepository
      .getAllRules()
      .then(
        ((response) => {
          this.libraryStore.setLibraryItems(response);
          this.cd.markForCheck();
        }).bind(this),
        ((error) => {
          console.error(
            TAG,
            "failed to load graphics rules library with error: ",
            error,
          );
        }).bind(this),
      )
      .catch(
        ((error) => {
          console.error(
            TAG,
            "failed to load graphics rules library with error: ",
            error,
          );
        }).bind(this),
      );
  }

  /**
   * Load Graphics Library from remote server
   * @return void
   */
  graphicsLibrary() {
    this.libraryStore.setLibraryItems([]);

    this.graphicsRepository
      .getAll()
      .then(
        ((items) => {
          console.log("got graphics ", this.libraryStore);

          if (this.libraryStore.library.type === LibraryTypes.Graphics) {
            this.libraryStore.setLibraryItems(items);
            this.cd.detectChanges();
          }
        }).bind(this),
        function (error) {
          console.error(TAG, "failed to load graphics from server: ", error);
        },
      )
      .catch(function (error) {
        console.error(TAG, "catching an error while loading graphics: ", error);
      });
  }

  onScroll() {
    if (this.searchService.searchMode === "video") {
      this.offset += 20;
      this.searchService
        .search(this.offset)
        .then((response: MediaItem[]) => {
          for (let i = 0; i < response.length; i++) {
            for (let j = 0; j < this.libraryStore.libraryItems.length; j++) {
              if (response[i].id === this.libraryStore.libraryItems[j].id) {
                response.splice(i, 1);
                i--;
                break;
              }
            }
          }
          this.libraryStore.setLibraryItems(
            this.libraryStore.libraryItems.concat(response),
          );
          this.changeDetectorRef.markForCheck();
        })
        .catch((err) => {
          console.error("Could not get media. Error: ", err);
        });
    }
  }
}
